import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0aefa8da"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "price-config box-flex-column" }
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { class: "page-header__left" }
const _hoisted_4 = { class: "page-title" }
const _hoisted_5 = { class: "industry-name" }
const _hoisted_6 = { class: "industry-name__value" }
const _hoisted_7 = { class: "page-header__actions" }
const _hoisted_8 = { class: "table-wrap" }
const _hoisted_9 = { class: "scene-bar" }
const _hoisted_10 = { class: "scene-count" }

import { computed, onMounted, reactive, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import {
  BaseButton,
  BaseInputNumber,
  XrkTable,
  XrkTableProps,
  XrkTableRef,
  useCreateModal,
  useTableColumn,
  XrkMessage,
  XrkMessageBox
} from 'xrk-components';
import SceneSelectDialog from '../components/scene-select-dialog.vue';
import { sceneManageDetail, sceneManageSave } from '../data-source/apis';
import { sceneManageToDisplayTranslator } from '../data-source/translators';
import type {
  SceneFlatItem,
  SceneManageProductItem
} from '../data-source/types';
import {
  expandDetailCol,
  indexCol,
  linkedProductCol,
  sceneNameCol,
  medicalRepTagCol,
  terminalServiceCol,
  projectIntroCol,
  platformPriceCol,
  updateDtCol
} from '../fields/columns';
import appStore from '@/store';
import { storeToRefs } from 'pinia';

type RowData = SceneFlatItem & {
  /** 工业价（元，translators 层已转；直接绑定编辑，空 = 继承平台价） */
  industryPriceLower?: number | null;
  industryPriceUpper?: number | null;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'i-price-config',
  setup(__props) {

const { info: userInfo } = storeToRefs(appStore.useUserStoreSetup);

const route = useRoute();
const router = useRouter();
const xrkTableRef = ref<XrkTableRef>(null);
const loading = ref(false);
const planId = ref<number | undefined>();
const industryId = ref<number | undefined>();
const industryName = ref<string>((userInfo.value.entpName as string) || '');
const allData = ref<RowData[]>([]);
const sceneData = ref<any[]>([]);
/** 原始全量 products（SceneManageProductItem[]，含 selected 标记，保存时全量提交） */
const productsData = ref<SceneManageProductItem[]>([]);
/** 编辑模式乐观锁：detail 返回的主表 updateDt，保存时作为 lastUpdateDt 传回 */
const lastUpdateDt = ref<string>('');
const isCreate = ref<boolean | null>(null);
const title = computed(() =>
  isCreate.value == null
    ? '工业场景价格配置'
    : isCreate.value
    ? '新增工业价格配置'
    : '编辑工业价格配置'
);
const openCount = computed(() => allData.value.length);

const paginationConfig = {
  paginationPageSize: 15
};

const searchConfig: XrkTableProps['searchConfig'] = {
  hide: true,
  searchColumns: []
};

const toRowData = (list: SceneFlatItem[]) =>
  list.map(item =>
    reactive<RowData>({
      ...item
    })
  );

/** 校验工业价格行（可提交校验）：空=继承平台价（合法）；成对填写；有值需 ≥0 且下限≤上限 */
const validate = (row: RowData) => {
  const lo = row.industryPriceLower;
  const hi = row.industryPriceUpper;
  if (lo == null && hi == null) return true;
  if (lo == null || hi == null) return false;
  if (!Number.isFinite(lo) || !Number.isFinite(hi)) return false;
  return lo >= 0 && hi >= 0 && lo <= hi;
};

/**
 * 价格提示文案（仅 UI 提示，不阻断提交）：优先级 未配置 → 缺一半 → 下限>上限 → 超平台区间 → 无提示
 */
const getPriceHint = (row: RowData): string => {
  const lo = row.industryPriceLower;
  const hi = row.industryPriceUpper;
  if (lo == null && hi == null) return '未配置，默认继承平台价';
  if (lo == null || hi == null) return '请填写完整价格区间';
  if (lo > hi) return '下限不能大于上限';
  if (
    lo < (row.platformPriceLower ?? 0) ||
    hi > (row.platformPriceUpper ?? 0)
  ) {
    return '当前价格超过平台区间';
  }
  return '';
};

/** 恢复平台价：清空工业价（null = 继承平台价） */
const onRestorePlatform = (row: RowData) => {
  row.industryPriceLower = null;
  row.industryPriceUpper = null;
  XrkMessage.success('已恢复为平台价');
};

const tableConfig: XrkTableProps['tableConfig'] = {
  baseConfig: { rowKey: '_id' },
  tableColumns: [
    expandDetailCol,
    indexCol,
    linkedProductCol,
    sceneNameCol,
    medicalRepTagCol,
    terminalServiceCol,
    projectIntroCol,
    platformPriceCol,
    useTableColumn({
      label: '工业执行价格区间',
      prop: 'industryPriceLower',
      width: 220,
      renderHeader: () => (
        <div style="text-align:center">
          <div>工业执行价格区间</div>
          <div style="font-size:12px;color:#9aa2ad">（项目结算单价）</div>
        </div>
      ),
      render: ({ row }: { row: RowData }) => (
        <div class="price-range-input">
          <div
            style="display:flex;align-items:center"
            class="price-range-input__row"
          >
            <BaseInputNumber
              style="width:100px"
              v-model={row.industryPriceLower}
              min={0}
              max={999999999}
              precision={2}
              controls={false}
              placeholder="下限"
            />
            <span class="price-range-input__sep"> ~ </span>
            <BaseInputNumber
              style="width:100px"
              v-model={row.industryPriceUpper}
              min={0}
              max={999999999}
              precision={2}
              controls={false}
              placeholder="上限"
            />
            <span class="price-range-input__unit">元</span>
          </div>
          {getPriceHint(row) ? (
            <div class="field-hint">{getPriceHint(row)}</div>
          ) : null}
        </div>
      )
    }),
    updateDtCol,
    useTableColumn({
      label: '操作',
      prop: 'handle',
      fixed: 'right',
      width: 120,
      render: ({ row }: { row: RowData }) => (
        <BaseButton link type="primary2" onClick={() => onRestorePlatform(row)}>
          恢复平台价
        </BaseButton>
      )
    })
  ] as any[]
};

/** 前端本地分页：全量数据在 allData 中，保存时取全量，翻页做本地切片 */
const getListAjax = async (params: Record<string, any>) => {
  const { pageNum = 1, pageSize = 15 } = params || {};
  const list = allData.value;
  const start = (pageNum - 1) * pageSize;
  return {
    data: { list: list.slice(start, start + pageSize), total: list.length }
  };
};

/** 加载详情（编辑模式：有 planId 时调用，sceneManageDetail planScope=1 返回 products[].scenes[]） */
const loadDetail = async () => {
  if (!industryId.value) return;
  loading.value = true;
  try {
    const res = await sceneManageDetail({
      planId: planId.value || undefined,
      industryId: industryId.value,
      detailMode: 2
    });
    const detail = res.data;
    // V2：detail 只返回已配置勾选数据（无 selected）；金额分→元已在 apis 层由 sceneManageDetailToYuan 转换
    productsData.value = detail?.products || [];
    // 编辑模式乐观锁：记录主表 updateDt，保存时作为 lastUpdateDt 传回
    lastUpdateDt.value = detail?.updateDt || '';
    isCreate.value = !planId.value;
    // 展示数据：translator 按 sceneId 合并（场景挂产品子集）
    const display = sceneManageToDisplayTranslator(productsData.value);
    // 平台价/工业价均为元（translators 层已转）；工业价直接绑定编辑（空 = 继承平台价）
    const flatItems: SceneFlatItem[] = display.map(
      scene =>
        ({
          ...scene,
          _id: String(scene.sceneId),
          sceneName: scene.sceneName,
          medicalRepTag: scene.medicalRepTag || '',
          terminalChannel: scene.terminalChannelText || '',
          serviceObject: scene.serviceObjectText || '',
          projectIntroduction: scene.projectIntroduction || '',
          sceneObjective: scene.sceneObjective || '',
          coreKpi: scene.coreKpi || '',
          platformPriceLower: scene.platformPriceLower ?? null,
          platformPriceUpper: scene.platformPriceUpper ?? null,
          updateDt: scene.updateDt || '',
          products: scene.products
        } as unknown as SceneFlatItem)
    );
    allData.value = toRowData(flatItems);
    sceneData.value = productsData.value;
    if (detail?.industryName) {
      industryName.value = detail.industryName;
    }
    xrkTableRef.value?.initList?.();
  } catch {
    XrkMessage.error('获取详情失败');
  } finally {
    loading.value = false;
  }
};

const onBack = async () => {
  try {
    await XrkMessageBox.confirm('是否确认返回列表', {
      confirmButtonText: '确定',
      cancelButtonText: '取消'
    });
    router.push('/main/i/scene-mgmt/main');
  } catch {
    /* 取消 */
  }
};

const onSave = async () => {
  if (!industryId.value) {
    XrkMessage.warning('缺少工业信息');
    return;
  }
  for (const row of allData.value) {
    if (!validate(row)) {
      XrkMessage.warning('请检查工业通用价区间');
      return;
    }
  }
  // 超出平台指导价确认（工业价有值时与平台价比较）
  if (
    allData.value.some(row => {
      const lo = row.industryPriceLower;
      const hi = row.industryPriceUpper;
      if (lo == null || hi == null) return false;
      return (
        lo < (row.platformPriceLower ?? 0) || hi > (row.platformPriceUpper ?? 0)
      );
    })
  ) {
    try {
      await XrkMessageBox.confirm('价格已超出平台指导价区间', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消'
      });
    } catch {
      return;
    }
  }
  // 场景金额联动：编辑行直接绑定 industryPriceLower/Upper（元），写回 products[].scenes 同 sceneId 场景
  // 提交时 buildSceneManageSaveParams 统一元→分；空值 = null = 继承平台价
  productsData.value.forEach(product => {
    (product.scenes || []).forEach(scene => {
      const row = allData.value.find(r => r.sceneId === scene.sceneId);
      if (row) {
        scene.industryPriceLower =
          row.industryPriceLower == null ||
          (row.industryPriceLower as unknown as string) === ''
            ? null
            : Number(row.industryPriceLower);
        scene.industryPriceUpper =
          row.industryPriceUpper == null ||
          (row.industryPriceUpper as unknown as string) === ''
            ? null
            : Number(row.industryPriceUpper);
      }
    });
  });
  // V2 整包保存：apis 层 buildSceneManageSaveParams 构造精简提交体 + 元→分；编辑时传 lastUpdateDt 乐观锁
  await sceneManageSave({
    planScope: 1,
    industryId: industryId.value,
    createType: 1,
    planId: planId.value || null,
    lastUpdateDt: lastUpdateDt.value || undefined,
    products: productsData.value
  });
  XrkMessage.success('已保存');
  router.push('/main/i/scene-mgmt/main');
};

/** 打开场景选择弹窗（emit 模式，与 a-plan-manual 一致） */
const onOpenPicker = () => {
  if (!industryId.value) {
    XrkMessage.warning('缺少工业信息');
    return;
  }
  useCreateModal(SceneSelectDialog, {
    products: productsData.value,
    industryName: industryName.value,
    industryId: industryId.value,
    planId: planId.value,
    onConfirm: (products: SceneManageProductItem[]) => {
      onSceneConfirm(products);
    }
  });
};

/** 场景选择弹窗确认回调：用 emit 全量数据替换本地 products + translator 重塑展示（不再调接口，保存统一走右上角按钮） */
const onSceneConfirm = (products: SceneManageProductItem[]) => {
  productsData.value = products;
  const display = sceneManageToDisplayTranslator(products);
  // 方案A：弹窗确定后保留用户已编辑的工业价（用旧 allData 的同 sceneId industryPrice 覆盖新数据）
  const prevPriceMap = new Map<
    number,
    { lower: number | null; upper: number | null }
  >();
  allData.value.forEach(row => {
    prevPriceMap.set(row.sceneId, {
      lower: row.industryPriceLower ?? null,
      upper: row.industryPriceUpper ?? null
    });
  });
  const flatItems: SceneFlatItem[] = display.map(
    scene =>
      ({
        ...scene,
        _id: String(scene.sceneId),
        sceneName: scene.sceneName,
        medicalRepTag: scene.medicalRepTag || '',
        terminalChannel: scene.terminalChannelText || '',
        serviceObject: scene.serviceObjectText || '',
        projectIntroduction: scene.projectIntroduction || '',
        sceneObjective: scene.sceneObjective || '',
        coreKpi: scene.coreKpi || '',
        platformPriceLower: scene.platformPriceLower ?? null,
        platformPriceUpper: scene.platformPriceUpper ?? null,
        updateDt: scene.updateDt || '',
        products: scene.products
      } as unknown as SceneFlatItem)
  );
  // 用旧 allData 的工业价（用户已编辑的 industryPriceLower/Upper）覆盖重建数据
  const newRows = toRowData(flatItems);
  newRows.forEach(row => {
    const prev = prevPriceMap.get(row.sceneId);
    if (prev) {
      row.industryPriceLower = prev.lower;
      row.industryPriceUpper = prev.upper;
    }
  });
  allData.value = newRows;
  xrkTableRef.value?.initList?.();
};

onMounted(() => {
  const queryPlanId = route.query.planId;
  const queryIndustryId = route.query.industryId;
  if (queryPlanId) {
    planId.value = Number(queryPlanId);
  }
  if (queryIndustryId) {
    industryId.value = Number(queryIndustryId);
  }
  // IAS 工业端：新建时 industryId 从当前登录企业取（工业价格配置页面定位于当前企业）
  if (!industryId.value) {
    industryId.value = Number((userInfo.value as any)?.finalDepId) || undefined;
  }
  if (!industryId.value) {
    XrkMessage.warning('缺少工业信息');
    return;
  }
  if (planId.value) {
    // 编辑：有 planId 才调 detail（已有数据才调用）
    loadDetail();
  } else {
    // 新建：无 planId 不调 detail（detail 无 planId 返回空配置无意义），直接新建态
    isCreate.value = true;
  }
});

return (_ctx: any,_cache: any) => {
  const _directive_xrk_loading = _resolveDirective("xrk-loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", _hoisted_4, _toDisplayString(title.value), 1),
        _createElementVNode("div", _hoisted_5, [
          _createTextVNode(" 工业名称： "),
          _createElementVNode("span", _hoisted_6, _toDisplayString(industryName.value), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_unref(BaseButton), {
          type: "default",
          onClick: onBack
        }, {
          default: _withCtx(() => [
            _createTextVNode("返回")
          ]),
          _: 1
        }),
        _createVNode(_unref(BaseButton), {
          type: "primary",
          click: onSave
        }, {
          default: _withCtx(() => [
            _createTextVNode("保存")
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_unref(XrkTable), {
        ref_key: "xrkTableRef",
        ref: xrkTableRef,
        getListAjax: getListAjax,
        searchConfig: searchConfig,
        tableConfig: tableConfig,
        paginationConfig: paginationConfig
      }, {
        tableBefore: _withCtx(() => [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_unref(BaseButton), {
              type: "primary",
              onClick: onOpenPicker
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 选择开通场景 ")
              ]),
              _: 1
            }),
            _createElementVNode("span", _hoisted_10, [
              _createTextVNode(" 已开通 "),
              _createElementVNode("b", null, _toDisplayString(openCount.value), 1),
              _createTextVNode(" 个场景 ")
            ])
          ])
        ]),
        _: 1
      }, 512)
    ])
  ])), [
    [_directive_xrk_loading, loading.value]
  ])
}
}

})